import * as React from 'react';
import DocumentTitle from '../misc/components/DocumentTitle';
import { DataCorrectionListScreen } from './List/DataCorrectionListScreen';
import { DataCorrectionRequestView } from './View/DataCorrectionRequestView';

export const DataCorrectionListAndViewScreen = () => {
    const listDocumentTitle = 'Data Corrections | Vitalograph Web Portal';
    const [selectedRequestDCFId, setSelectedRequestDCFId] = React.useState(null);
    const [showList, setShowList] = React.useState<boolean>(true);
    const [showView, setShowView] = React.useState<boolean>(false);
    const [documentTitle, setDocumentTitle] = React.useState<string>(listDocumentTitle);
    const rowSelectionChanged = (dcfRequestId) => {
        setSelectedRequestDCFId(dcfRequestId);
        setShowList(false);
        setShowView(true);
    }

    const rowDetailsClose = () => {
        setShowList(true);
        setShowView(false);
        setSelectedRequestDCFId(null);
        setDocumentTitle(listDocumentTitle);
    }

    const visibleStyle = {
        display: 'inline'
    }
    const invisibleStyle = {
        display: 'none'
    }

    return (
        <DocumentTitle title={documentTitle}>
            <div>
                <div style={showList ? visibleStyle : invisibleStyle}>
                    <DataCorrectionListScreen rowSelectionChanged={(dcfRequestId) => rowSelectionChanged(dcfRequestId)} />
                </div>
                <div style={showView ? visibleStyle : invisibleStyle}>
                    <DataCorrectionRequestView dcfRequestId={selectedRequestDCFId} onClose={() => rowDetailsClose()} />
                </div>
            </div>
        </DocumentTitle>
    );
};
